import { cn } from "lib/utils";

const Spacer = ({ className }: { className?: string }) => {
  return <div className={cn("grow -mx-md", className)} />;
};

export default Spacer;
